import { useMailMessage } from "../../hooks/useMailMessage.js";
import { MailMessageFullView } from "./index.js";
import "react";
import { Skeleton } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
// src/modules/Mail/components/MailMessageFullView/MailMessageFullViewFromId.tsx
function MailMessageFullViewFromId({ hideBody, hideCcUserAndGroups, hideFileUrls, hideSender, hideSentAt, hideSubject, hideToUserAndGroups, mailMessageId }) {
	const { data, loading } = useMailMessage(mailMessageId && { mailMessageId });
	if (loading && !data?.mailMessage) return /* @__PURE__ */ jsx(Skeleton, {
		height: 80,
		fillContainer: true
	});
	if (!loading && data?.mailMessage) return /* @__PURE__ */ jsx(MailMessageFullView, {
		body: hideBody ? void 0 : data.mailMessage.bodyHtml || data.mailMessage.body,
		ccUserAndGroups: hideCcUserAndGroups ? void 0 : data.mailMessage.ccUserAndGroups,
		fileUrls: hideFileUrls ? void 0 : data.mailMessage.fileUrls,
		sender: hideSender ? void 0 : data.mailMessage.sender,
		sentAt: hideSentAt ? void 0 : data.mailMessage.sentAt,
		subject: hideSubject ? void 0 : data.mailMessage.subject,
		receiverUserAndGroups: hideToUserAndGroups ? void 0 : data.mailMessage.receiverUserAndGroups
	});
	return null;
}
export { MailMessageFullViewFromId };

//# sourceMappingURL=MailMessageFullViewFromId.js.map